enum FlexibleDataModelType {
  Form = 'Form',
  Table = 'Table',
  Section = 'Section',
}

export default FlexibleDataModelType;
